import { render, staticRenderFns } from "./Time.vue?vue&type=template&id=38a655f9&scoped=true"
import script from "./Time.vue?vue&type=script&lang=ts"
export * from "./Time.vue?vue&type=script&lang=ts"
import style0 from "./Time.vue?vue&type=style&index=0&id=38a655f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a655f9",
  null
  
)

export default component.exports